import React from 'react';
import icon from '../images/logo-accedo.svg';
import controlIcon from '../images/logo-accedo-control.svg';
import styles from './Logo.scss';
import { isControlUrl } from '../utils/url';

const isControl = isControlUrl();

const Logo = () => {
  return (
    <div className={styles.root}>
      <img
        src={isControl ? controlIcon : icon}
        className={styles.icon}
        alt={`Logotype - ${isControl ? 'Accedo Control' : 'Accedo'}`}
      />
      <h1 className="sr-only">{isControl ? 'Accedo Control' : 'Accedo'}</h1>
    </div>
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/client/src/components/Logo.js